export default __webpack_public_path__ + "assets/js/pdf.worker.min-7392c641367b19121a6953313cee5cc5.js";